module.exports = __webpack_public_path__ + "static/media/Songs 3.d736e25e.svg";